module.exports = __webpack_public_path__ + "03dc44d174bc5db1a91021a2a39a570f.fbx";